module.exports = __webpack_public_path__ + "img/product-banner6.4c332f78.jpg";